/* eslint-disable no-param-reassign */
import { PagerNewCurrentPageEvent } from '../../1-atoms/pager/pager';

const create = ($ribbonSlider: HTMLDivElement): CallableFunction => {
  const $cards = $ribbonSlider.querySelector<HTMLDivElement>(
    '.ribbon-slider__cards',
  );

  if (!$cards) {
    throw new Error('Cards are missing!');
  }

  const setCurrentPage = (page: number) => {
    Array.from($cards.children).forEach((card, i) => {
      if (i >= page * 2 && i < page * 2 + 2) {
        card.ariaHidden = null;
        (card as HTMLElement).inert = false;
      } else {
        card.ariaHidden = 'true';
        (card as HTMLElement).inert = true;
      }
    });
  };

  const onPage = (event: PagerNewCurrentPageEvent) => {
    const { currentPage } = event.detail;
    setCurrentPage(currentPage);

    $cards.style.transform = `translateX(-${currentPage * 100}%)`;
  };

  setCurrentPage(0);
  $ribbonSlider.addEventListener('pager:page', onPage);
  $cards.ariaLive = 'off';

  return () => {
    $ribbonSlider.removeEventListener('pager:page', onPage);
  };
};

export default create;
